module.exports = __webpack_public_path__ + "static/phone-slide-2-5282320a6aab5a047e18532e26977140.png";